import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Container } from '../ui/Container/Container';
import { useScrollReveal } from './useScrollReveal';
import { useAuthStore } from '../../stores/authStore';

const IS_ALPHA = import.meta.env.VITE_IS_ALPHA === 'true';

export function LandingCta() {
  const ref = useScrollReveal<HTMLDivElement>();
  const user = useAuthStore((s) => s.user);

  return (
    <section className="py-12 md:py-20 text-center relative" style={{ background: '#1d2939' }}>
      <Container size="lg" className="max-w-[1100px]">
        <div ref={ref} className="lp-reveal">
          <h2
            className="text-[clamp(1.8rem,4.5vw,2.8rem)] mb-3 leading-[1.1]"
            style={{
              fontFamily: "'Playfair Display',Georgia,serif",
              fontWeight: 400,
              fontStyle: 'italic',
              color: 'white',
            }}
          >
            Your next image is one node away.
          </h2>
          <p className="text-[0.95rem] mb-6" style={{ color: 'rgba(255,255,255,0.6)' }}>
            {IS_ALPHA
              ? 'Start building on the canvas. 7-day free trial.'
              : 'Start building on the canvas. Plans from $19/month.'}
          </p>
          <Link
            to={user ? '/canvas' : '/auth?tab=register'}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-[0.9rem] font-medium text-[#1d2939] no-underline transition-all hover:scale-[1.03]"
            style={{
              background: 'linear-gradient(135deg, #c8d45a 0%, #a8b44a 100%)',
              boxShadow: '0 2px 12px rgba(200,212,90,0.3)',
            }}
          >
            {IS_ALPHA ? 'Start Creating' : 'Start Creating'}
            <ArrowRight className="w-4 h-4" />
          </Link>
          <p className="text-[0.7rem] mt-3" style={{ color: 'rgba(255,255,255,0.35)' }}>
            {IS_ALPHA ? '7-day free trial · Cancel anytime' : 'Cancel anytime · No long-term commitment'}
          </p>
        </div>
      </Container>
    </section>
  );
}
